export default __webpack_public_path__ + "ff2cba0d28486d9dbdd2a7f07cdf662d.svg";